import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

export function WarehouseSettingsBreadcrumb({ items }) {
  return (
    <Breadcrumb
      items={items.map(({ label, to }) => ({
        title: to ? <Link to={to}>{label}</Link> : label,
      }))}
    />
  );
}
